<template>
  <div class="experiment ma-0 p-3">
    <v-row class="pt-0 p-5">
      <v-col>
        <v-expansion-panels v-model="controlPanel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header color="grey lighten-4">
              <h6>{{ $t("manage.by_school.experiment.command_send.send_command.header") }}</h6>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-row>
                <v-col class="mt-2" cols="12">
                  <v-text-field
                    dense
                    v-model="form.school_id"
                    :label="commandSendLabel('school_label')"
                    readonly
                    disabled
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    :items="api.experiments"
                    item-text="experiment_set"
                    item-value="experiment_set"
                    v-model="form.experiment_set"
                    :label="commandSendLabel('experiment_set_label')"
                    no-data-text="No Experiment Available"
                    @change="changeExperimentSet(form.experiment_set);"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="form.command"                    
                    :label="commandSendLabel('command_label')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>                  
                  <div class="d-flex justify-end">
                    <v-btn color="primary" @click="setCommand">{{ $t("manage.by_school.experiment.command_send.send_command.btn_send") }}</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header color="grey lighten-4">
              <h6>{{ $t("manage.by_school.experiment.command_send.reset_chart.header") }}</h6>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col class="mt-2" cols="12">
                  <v-text-field
                    dense
                    v-model="form.reset_school_id"
                    :label="resetChartLabel('school_label')"
                    readonly
                    disabled
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    :items="api.experiments"
                    item-text="experiment_set"
                    item-value="experiment_set"
                    v-model="form.reset_experiment_set"
                    :label="resetChartLabel('experiment_set_label')"
                    no-data-text="No Experiment Available"
                    @change="changeResetExperimentSet(form.reset_experiment_set);"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>                  
                  <div class="d-flex justify-end">
                    <v-btn color="primary" @click="setChart">{{ $t("manage.by_school.experiment.command_send.reset_chart.btn_reset") }}</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from "moment";
import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);

import { api_experiment } from "@/services/iot/api_experiment";
const apiExperiment = new api_experiment(process.env.VUE_APP_BASE_URL);


export default {
  name: "experiment",
  components: {},
  mixins: [],
  data: function () {
    return {
      school_id: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      activeDialog: false,
      activeItems: [{ status: "ACTIVE" }, { status: "HOLD" }],
      current: {
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      
      controlPanel: [],
      admin: false,
      user: [
        {
          name: null,
          level: null,
        },
      ],
      form: {
        school_id: "",
        experiment: "",
        equipment_id: "",
        experiment_set: "",
        device_id: "",
        command: "",
        
        reset_school_id: "",
        reset_experiment: "",
        reset_equipment_id: "",
        reset_experiment_set: "",
      },
      api: {
        schools: [],
        equipments: [],
      },
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    
    self.api.schools = [self.current.school_id];

    self.school_id = self.$route.params.school_id;
    self.form.school_id = self.school_id;
    self.form.reset_school_id = self.school_id;

    self.getSchoolExperiment();
    if(self.admin){
      self.getSchoolList();
    }
    self.getExperimentList();
    
  },
  methods: {    
    commandSendLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc') {
        if (label=='school_label') return self.$t("manage.by_school.experiment.command_send.school");
        else if (label=='experiment_set_label') return self.$t("manage.by_school.experiment.command_send.experiment_set");
        else if (label=='command_label') return self.$t("manage.by_school.experiment.command_send.send_command.command");
      }
      else {
        if (label=='school_label') return self.$t("manage.by_school.experiment.command_send.school");
        else if (label=='experiment_set_label') return self.$t("manage.by_school.experiment.command_send.experiment_set");
        else if (label=='command_label') return self.$t("manage.by_school.experiment.command_send.send_command.command");
      }
    }, 
    resetChartLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc') {
        if (label=='school_label') return self.$t("manage.by_school.experiment.command_send.school");
        else if (label=='experiment_set_label') return self.$t("manage.by_school.experiment.command_send.experiment_set");
      }
      else {
        if (label=='school_label') return self.$t("manage.by_school.experiment.command_send.school");
        else if (label=='experiment_set_label') return self.$t("manage.by_school.experiment.command_send.experiment_set");
      }
    },
    setCommand: function () {
      var self = this;
      apiExperiment.setCommand(
        'super',
        'overrider',
        self.form.school_id,
        self.form.experiment.toUpperCase(),
        self.form.equipment_id,
        'device_1',
        self.form.command
      )
      .then((response) => {
        console.log(response);
          if(response.status == "success"){
            alert("Command to experiment: " + self.form.experiment + " (" + self.form.equipment_id + ", device_1) is sent.");
            //self.restartDialog = false;
          }
          else {
            alert("Fail. Command to " + self.form.experiment + " (" + self.form.equipment_id + ") does not send!");
          }
      });
    },
    setChart: function () {
      var self = this;

      if( self.form.reset_experiment.toUpperCase()=="GREENHOUSE" ){
        apiExperiment.clearChartMultiple(
          self.form.reset_school_id,
          self.form.reset_experiment.toUpperCase(),
          self.form.reset_equipment_id,
          'device_1',
          2,
          'Temp_1,Temp_2',
        )
        .then((response) => {
          console.log(response);
          
            if(response.status == "success")
              alert("Experiment Data is reset: " + self.form.reset_experiment + " (" + self.form.reset_equipment_id + ").");
            else
              alert("Fail. Experiment data does not reset " + self.form.reset_experiment + " (" + self.form.reset_equipment_id + ")!");
          
          });
      }
      else {
        apiExperiment.setChart(
          self.form.reset_school_id,
          self.form.reset_experiment.toUpperCase(),
          self.form.reset_equipment_id,
          'device_1',
          '[]'
        )
        .then((response) => {
          console.log(response);
            if(response.status == "success")
              alert("Experiment Data is reset: " + self.form.reset_experiment + " (" + self.form.reset_equipment_id + ").");
            else
              alert("Fail. Experiment data does not reset " + self.form.reset_experiment + " (" + self.form.reset_equipment_id + ")!");
          });
      }
    },
    changeExperimentSet(experiment_set){
      var self = this;
      let split = experiment_set.split(" - ");
      self.form.experiment = split[0];
      self.form.equipment_id = split[1];
    },
    changeResetExperimentSet(reset_experiment_set){
      var self = this;
      let split = reset_experiment_set.split(" - ");
      self.form.reset_experiment = split[0];
      self.form.reset_equipment_id = split[1];
    },
    getSchoolList(){
      var self = this;
      apiManagement.getSchoolList()
      .then((response) => {
          self.api.schools = response.schools;
      });
    },
    getSchoolExperiment() {
      var self = this;
      apiManagement.getSchoolExperiment(self.current.school_id).then((response) => {
        self.api.experiments = response.experiments;
      });
    },
    getExperimentList(){
      var self = this;
      apiManagement.getExperimentList()
      .then((response) => {
          self.api.experiments_list = response.experiments;
      });
    },
    formatDate(value) {
      if (value == 0) {
        return "";
      } else {
        return moment(value * 1000).fromNow();
      }
    },
    isOverOneDay(target) {
      var d = Math.floor(Date.now() / 1000);
      if (d - parseInt(target) > 60 * 60 * 24 && target != 0) {
        return true;
      } else {
        return false;
      }
    },
    refresh() {
      this.getSchoolEquipmentCommandList();
    },
  },
  destroyed() {
    console.log("destroyed");
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>